import { PaginatedResponse } from '@/types/PaginatedResponse'
import BaseService from './baseService'
import { SegmentTemplateResponse } from '@/types/segmentTemplateResponse'
import { SegmentTemplateInsightsResponse } from '@/types/SegmentTemplateInsightsResponse'
import EndPoints from '@/constants/dxApiEndpoints'

class SegmentTemplateService extends BaseService {
  async GetSegmentTemplates(
    businessProfileId: number,
    pageNumber: number = 1,
    pageSize: number = 10,
    searchTerm: string
  ): Promise<PaginatedResponse<SegmentTemplateResponse>> {
    const response = await this.apiClient.get<
      PaginatedResponse<SegmentTemplateResponse>
    >(EndPoints.CustomerSegmentTemplates(businessProfileId), {
      pageNumber,
      pageSize,
      searchTerm
    })
    return response.data
  }
  async GetSegmentTemplateInsights(
    businessProfileId: number,
    segmentTemplateId: number
  ): Promise<SegmentTemplateInsightsResponse> {
    const response = await this.apiClient.get<SegmentTemplateInsightsResponse>(
      EndPoints.CustomerSegmentTemplateInsights(
        businessProfileId,
        segmentTemplateId
      )
    )
    return response.data
  }
}

export default SegmentTemplateService
